// Time required per input × output quadrant, shown as a table under the matrix.
import type { MatrixCell } from '../api';

function tokenLabel(n: number): string {
  return n >= 1000 && n % 1000 === 0 ? `${n / 1000}k` : String(n);
}

export default function MatrixTimingTable({
  inputTokens,
  outputTokens,
  cells,
}: {
  inputTokens: number[];
  outputTokens: number[];
  cells: MatrixCell[];
}) {
  const byKey = new Map(cells.map((c) => [`${c.inputTokens}x${c.outputTokens}`, c]));
  const rows = [...outputTokens].sort((a, b) => b - a);
  const any = cells.some((c) => c.meanTotalMs != null || c.errored || c.skipped);
  if (!any) return null;

  const fmt = (c?: MatrixCell): string => {
    if (!c) return '–';
    if (c.skipped) return 'skip';
    if (c.errored) return 'fail';
    if (c.meanTotalMs == null) return '–';
    const s = c.meanTotalMs / 1000;
    return s >= 10 ? `${s.toFixed(0)} s` : `${s.toFixed(1)} s`;
  };

  return (
    <div className="timing-table">
      <div className="timing-title">Time per quadrant (mean wall-clock, input × output)</div>
      <div className="table-scroll">
        <table className="table compact">
          <thead>
            <tr>
              <th>out ↓ / in →</th>
              {inputTokens.map((it) => (
                <th key={it} className="num">
                  {tokenLabel(it)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((ot) => (
              <tr key={ot}>
                <th>{ot}</th>
                {inputTokens.map((it) => {
                  const c = byKey.get(`${it}x${ot}`);
                  return (
                    <td
                      key={it}
                      className={`num${c?.errored ? ' cell-fail' : ''}${
                        c?.skipped ? ' cell-skip' : ''
                      }`}
                    >
                      {fmt(c)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
